import React, { ReactNode, useState } from 'react';
import { ScaleContext, type ScaleValue } from './ScaleContext';

interface ScaleProviderProps {
  children: ReactNode;
  defaultScale?: ScaleValue;
}

export function ScaleProvider({
  children,
  defaultScale = '1',
}: ScaleProviderProps) {
  const [scale, setScale] = useState<ScaleValue>(() => {
    // Check if we're on the client side
    if (typeof window !== 'undefined') {
      // Try to get saved scale from localStorage
      const savedScale = localStorage.getItem('interface-scale') as ScaleValue;
      return savedScale || defaultScale;
    }
    return defaultScale;
  });

  const handleSetScale = (newScale: ScaleValue) => {
    setScale(newScale);
    // Check if we're on the client side before saving to localStorage
    if (typeof window !== 'undefined') {
      localStorage.setItem('interface-scale', newScale);
    }
  };

  return (
    <ScaleContext.Provider value={{ scale, setScale: handleSetScale }}>
      {children}
    </ScaleContext.Provider>
  );
}
